import AccrualsGrid from './components/AccrualsGrid/AccrualsGrid.vue';

export default {
    components: { AccrualsGrid },
}